import React, { useState } from "react";
import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";
import MDBox from 'components/MDBox';
import { isEmpty } from "utils/validationUtil";
import { IconButton } from "@mui/material";
import { Edit, Delete as DeleteIcon } from "components/icons";
import { useResizableColumnWidths } from "app/hooks/useResizableColumnWidths";
import { DEFAULT_TABLE_PAGE_SIZE } from "AppConstants";


export const WorkingHoursDataGrid = (props) => {
    const {workingHours} = props;
    const [pageSize, setPageSize] = useState(10);
    
    // A read-only viewer gets no Actions column at all, rather than buttons that do nothing.
    // HRMS-116 point 6: a BDM sees working hours read-only. @since NEXT_VERSION
    const columns = [
        ...(props.isReadOnly ? [] : [{
            field: "actions",
            type: "actions",
            headerName: "Actions",
            width: 100,
            cellClassName: "actions",
            getActions: (obj) => {
                return [
                  <IconButton
                    aria-label="Edit"
                    onClick={() => props.editEventHandler(obj.row)}
                    color="inherit"
                  >
                    <Edit />
                  </IconButton>,
                  <IconButton
                    aria-label="Delete"
                    onClick={() => props.confirmDeleteDialogHandler(obj.row)}
                    color="inherit"
                  >
                    <DeleteIcon />
                  </IconButton>,
                ];
            }, // getAction
          }]),
        { field: 'id', headerName: 'Id', width: 120 },
        { field: 'location', headerName: 'Location', width: 250},
        { field: 'Client', headerName: 'Client', width: 250, valueGetter: (value, row) => row.client.name  },
        { field: 'hour', headerName: 'Hour', width: 250 },
    ]

    // Keeps a dragged column width alive across the re-render that editing or deleting a
    // row causes.
    const { columns: sizedColumns, onColumnWidthChange } = useResizableColumnWidths(columns);

    const getData = () => {
        if(isEmpty(workingHours) || workingHours.length === 0)
            return [];
        else
            return workingHours;
    }
    
    return (
        <MDBox py={1.5}
            px={2}
        >
            <DataGrid
                density="compact"
                autoHeight
                rows={ getData() }
                columns={sizedColumns}
                onColumnWidthChange={onColumnWidthChange}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                loading={props.isLoading}
                // Id hidden by default; the old `hide: true` column flag no longer exists in DataGrid v8.
                initialState={{
                    columns: { columnVisibilityModel: { id: false } },
                    pagination: { paginationModel: { pageSize: DEFAULT_TABLE_PAGE_SIZE } },
                }}
            />
        </MDBox>
    );
}

WorkingHoursDataGrid.propTypes = {
  workingHours: PropTypes.array.isRequired
}